// extracted by mini-css-extract-plugin
export default {"header":"Header_header__r5NRu","title":"Header_title__8VG9g","actions":"Header_actions__Hgbh8","toggler":"Header_toggler__qu+1O","inverted":"Header_inverted__HCJCH"};